var map = {
	"./brand/reduced": 197,
	"./brand/reduced.svg": 197,
	"./brand/regular": 198,
	"./brand/regular.svg": 198,
	"./favicons/favicon-16x16": 199,
	"./favicons/favicon-16x16.png": 199,
	"./favicons/favicon-32x32": 200,
	"./favicons/favicon-32x32.png": 200,
	"./favicons/favicon-96x96": 201,
	"./favicons/favicon-96x96.png": 201,
	"./menu/event_logo": 202,
	"./menu/event_logo.png": 202,
	"./menu/logo": 203,
	"./menu/logo.svg": 203,
	"./menu/user": 204,
	"./menu/user.svg": 204,
	"./spinner": 205,
	"./spinner.svg": 205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;